// extracted by mini-css-extract-plugin
export var fullscreen = "style-mod--fullscreen--3055b";
export var ldsEllipsis = "style-mod--lds-ellipsis--2b986";
export var ldsEllipsis1 = "style-mod--lds-ellipsis1--af674";
export var ldsEllipsis2 = "style-mod--lds-ellipsis2--df2e6";
export var ldsEllipsis3 = "style-mod--lds-ellipsis3--a4d2b";
export var loader = "style-mod--loader--de291";